<template>
	<html>
		<body>
			<div id="app">
				<App :shadow-root="shadowRoot || null" />
			</div>
		</body>
	</html>
</template>

<script lang="ts" setup>
import { useShadowRoot, watch } from 'vue';
import 'shepherd.js/dist/css/shepherd.css';
import { i18n } from '@/localization/localization';

import '@/ce/index.css';
import App from './App.vue';
import { LocaleEnum } from './enums/Locale.enum';

const props = defineProps<{ ngProps?: { language?: LocaleEnum } }>();

const shadowRoot = useShadowRoot();

// Watch for language changes from parent app
watch(
	() => props.ngProps,
	async (newNgProps) => {
		const { language } = newNgProps ?? {};
		if (!language) return;

		const isLanguageValid = Object.values(LocaleEnum).includes(language);
		if (!isLanguageValid) return;

		(i18n.global as any).locale.value = language;
	},
	{ immediate: true }
);
</script>

<style lang="scss">
@import 'src/style/index.scss';
</style>
